'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { ErrorBlock } from 'src/components/ErrorBlock';
import { Layout } from 'src/layout';

export default function ErrorPage() {
  useEffect(() => {
    globalThis.document.title = 'Ошибка 500';

    const transactionName = 'error 500';
    const url = window.location.href;

    Sentry.withScope(function (scope) {
      scope.setTransactionName(transactionName);
      Sentry.setTag('Error 500', url);
      scope.setFingerprint([`error 500 - ${url}`]);
      Sentry.captureException(new Error(`Error500 - ${url}`), scope);
    });
  }, []);

  return (
    <Layout>
      <ErrorBlock errorCode={500} />
    </Layout>
  );
}
